export default [
    { id: 'carouselhydrological1', title: 'Caudal', src: 'caudal.png', src_hover: 'caudal_h.png', pdf: 'caudal.pdf' },
    { id: 'carouselhydrological2', title: 'Nivel', src: 'nivel.png', src_hover: 'nivel_h.png', pdf: 'nivel.pdf'}
]